import React, { useState, useEffect } from "react";
import { fetchRolePermissions, upsertRolePermission } from "../../services/Administracion/rolePermissionService";
import { fetchRoles } from "../../services/Administracion/rolesService";
import { fetchPermissions } from "../../services/Administracion/permissionService";
import { Role } from "../../types/roles";
import { Permission } from "../../types/permission";
import { useAuth } from "../../context/AuthContext";
import { RolePermission } from "../../types/rolePermission";
import  RolePermissionModal  from '../Administracion/RolesPermissionsModal';

const RolePermissionList: React.FC = () => {
    const { user } = useAuth();
    const [roles, setRoles] = useState<Role[]>([]);
    const [permissions, setPermissions] = useState<Permission[]>([]);
    const [rolePermissions, setRolePermissions] = useState<RolePermission[]>([]);
    const [selectedRolePermission, setSelectedRolePermission] = useState<RolePermission | null>(null);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const loadData = async () => {
        setLoading(true);
        setError(null);
        try {
            const [rolePermissionData, rolesData, permissionsData] = await Promise.all([
                fetchRolePermissions(),
                fetchRoles(),
                fetchPermissions()
            ]);
            setRoles(rolesData);
            setPermissions(permissionsData);
            setRolePermissions(rolePermissionData);

        } catch (error: any) {
            setError(error.message || 'Error al cargar datos');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    const handleOpenModal = (rolePermiso?: RolePermission) => {
        setSelectedRolePermission(rolePermiso || null);
        setShowModal(true);
    };

    const handleSaveRolePermission = async (rolePermission: RolePermission) => {
        try {
            rolePermission.created_by = user?.User.email;
            rolePermission.updated_by = user?.User.email;

            await upsertRolePermission(rolePermission);
            loadData();    
        } catch (error: any) {
            setError(error.message || 'Error al guardar el permiso del rol');
        } finally {
            setShowModal(false);
        }
    };

    if (loading) return <div>Cargando datos...</div>;
    if (error) return <div className="text-danger">Error: {error}</div>;

    return (
        <div className="container mt-4">
            <h4>Asignar Permisos Directos a Roles</h4>
            <div className="mb-3 text-end">
                <button
                    className="btn btn-primary mb-3"
                    onClick={() => handleOpenModal()}
                >
                    Asignar Permiso a Rol
                </button>
            </div>
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th>Rol</th>
                        <th>Permiso</th>
                        <th>Activo</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {rolePermissions.map((rp, index) => {
                        const role = roles.find(r => r.role_id === rp.role_id);
                        const permission = permissions.find(p => p.permission_id === rp.permission_id);
                        return (
                            <tr key={index}>
                                {/* <td>{rp.role_id}</td> */}
                                <td>{role?.role_name} - ({rp.role_id})</td>
                                <td>{permission?.permission_name} - ({rp.permission_id})</td>
                                <td>{rp.is_active ? 'Si' : 'No'}</td>
                                <td>
                                    <button
                                        className="btn btn-secondary btn-sm"
                                        onClick={() => handleOpenModal(rp)}
                                    >
                                        Editar
                                    </button>
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {showModal && (
                <RolePermissionModal
                  rolePermission={selectedRolePermission}
                  rolePermissions={rolePermissions}
                  roles={roles}
                  permissions={permissions}
                  onClose={()=> setShowModal(false)}
                  onSave={handleSaveRolePermission}
                />
            )}
        </div>

    )
};

export default RolePermissionList;